<template>
  <div>
    <v-subheader class="label" v-if="label.length>0">{{label}}</v-subheader>
    <v-layout row wrap>
      <v-flex md3>
        <input
          v-model.number="hour"
          label="時"
          :readonly="readonly"
          min="0"
          type="number"
          suffix="時"
        />
      </v-flex>
      <v-flex md1>時</v-flex>
      <v-flex md3 offset-md1>
        <input
          v-model.number="min"
          label="分"
          :readonly="readonly"
          max="59"
          min="0"
          type="number"
          suffix="分"
        />
      </v-flex>
      <v-flex md1>分</v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data: () => ({
    minutes: [],
    minNoDataText: ""
  }),
  props: {
    value: {
      default: 0,
      type: Number
    },
    readonly: {
      default: false,
      type: Boolean
    },
    label: {
      default: "",
      type: String
    }
  },
  computed: {
    hour: {
      get() {
        return Math.floor(this.value / 3600);
      },
      set(hour) {
        this.$emit("input", hour * 3600 + this.min * 60);
      }
    },
    min: {
      get() {
        return Math.floor((this.value % 3600) / 60);
      },
      set(min) {
        this.$emit("input", this.hour * 3600 + min * 60);
      }
    }
  },
  created() {
    if (this.isBy10Minutes) {
      this.minutes = [0, 10, 20, 30, 40, 50];
      this.minNoDataText =
        "0から50までの半角数字を10分単位で入力してください。";
    } else {
      this.minutes = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        59
      ];
      this.minNoDataText =
        "0から50までの半角数字を10分単位で入力してください。";
    }
  }
};
</script>
<style lang="css" scoped>
select {
  border-radius: 0;
  border: solid 1px gray;
  width: 100%;
  -webkit-appearance: menulist;
}
input {
  border-radius: 0;
  border-bottom: solid 1px gray;
  width: 100%;
}
.label {
  padding: 0;
  height: 30px;
  font-size: 12px;
}
</style>

